import { cn } from '@/shared/lib/utils';
import { getStatusVisual } from './appointment-status-visual';

export interface AppointmentStatusPillProps {
  status: string;
  className?: string;
}

/** Read-only status pill for list / detail surfaces. */
export function AppointmentStatusPill({ status, className }: AppointmentStatusPillProps) {
  const cfg = getStatusVisual(status);
  return (
    <span className={cn('pill', cfg.bg, cfg.text, className)}>
      <span className={cn('pill-dot', cfg.dot)} />
      {cfg.label}
    </span>
  );
}
